import DeviceConnectionRedirect, {
  ConnectionStatusMode,
  Props as DeviceConnectionRedirectProps,
} from '@/authenticated/components/DeviceConnectionRedirect'
import { NavigationPage } from '@/app/components'
import { useHistory } from 'react-router-dom'
import { Redirect } from 'react-router'
import { useAppSelector } from '@/hooks'
import { Vehicle } from '@/types/vehicle'

export interface Props extends DeviceConnectionRedirectProps {
  actionDisabled: boolean
  shouldRedirectToAva: boolean | undefined
}

function TeslaFleetRedirectContent(props: Props) {
  const history = useHistory()

  const connectedVehicles = useAppSelector(
    (state) => state.vehicleAuth.mfaData ?? [],
  ) as Vehicle[] | undefined

  const {
    actionDisabled,
    missingScopes,
    shouldRedirectToAva,
    ...deviceConnectionRedirectProps
  } = props

  const urlPrefix = shouldRedirectToAva ? '/ava/onboarding' : ''

  if (
    props.mode === ConnectionStatusMode.Connected &&
    connectedVehicles?.length
  ) {
    return (
      <Redirect
        to={`${urlPrefix}/tesla-authentication/verify-permissions/${connectedVehicles
          .map((vehicle) => vehicle.id)
          .join(',')}`}
      />
    )
  }

  if (
    props.mode === ConnectionStatusMode.Connected &&
    connectedVehicles?.length === 0
  ) {
    return (
      <Redirect
        to={`${urlPrefix}/tesla-authentication/no-vehicle-information`}
      />
    )
  }

  const handleBackClick = () => {
    history.go(-2) // skip past the tesla auth page
  }

  return (
    <DeviceConnectionRedirect
      {...deviceConnectionRedirectProps}
      disableButton={props.actionDisabled}
      backButtonAction={handleBackClick}
    />
  )
}

export default function TeslaFleetRedirect(props: Props) {
  return (
    <NavigationPage id="tesla-fleet-redirect">
      <TeslaFleetRedirectContent {...props} />
    </NavigationPage>
  )
}
